import { SVGProps } from 'react';

function Lock(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={16}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M2.5 9A1.5 1.5 0 0 1 4 7.5h8A1.5 1.5 0 0 1 13.5 9v6a1.5 1.5 0 0 1-1.5 1.5H4A1.5 1.5 0 0 1 2.5 15V9Z"
        stroke="#BABEC9"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 7.5V5a3.5 3.5 0 1 1 7 0v2.5M8 11v2"
        stroke="#BABEC9"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Lock.defaultProps = {
  role: 'graphics-document',
};

export default Lock;
